import { render } from "./UnfoldMoreHorizontal.vue?vue&type=template&id=631c380f"
import script from "./UnfoldMoreHorizontal.vue?vue&type=script&lang=js"
export * from "./UnfoldMoreHorizontal.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/UnfoldMoreHorizontal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "631c380f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('631c380f', __exports__)) {
    api.reload('631c380f', __exports__)
  }
  
  module.hot.accept("./UnfoldMoreHorizontal.vue?vue&type=template&id=631c380f", () => {
    api.rerender('631c380f', render)
  })

}


export default __exports__